// Centralized content for Pie in the Sky Productions
// Migrated + expanded from www.pieinthesky.co.za

export const LOGO_ICON = "https://customer-assets.emergentagent.com/job_migration-preserve/artifacts/osn8g1i4_PITS%20Logo.png";
export const LOGO_LOCKUP = "https://customer-assets.emergentagent.com/job_migration-preserve/artifacts/t19pj3p7_Transparent%20New%20logo%20White%20Text.png";

export const SITE = {
  brand: "Pie in the Sky Productions",
  shortName: "Pie in the Sky Productions",
  location: "Cape Town, South Africa",
  domain: "www.pieinthesky.co.za",
  url: "https://www.pieinthesky.co.za",
  tagline: "Crafting visual narratives that captivate & convert.",
  email: "info@pieinthesky.co.za",
  phone: "+27 66 122 9790",
  address: {
    streetAddress: "Cape Town",
    addressLocality: "Cape Town",
    addressRegion: "Western Cape",
    postalCode: "8001",
    addressCountry: "ZA",
  },
  geo: { latitude: -33.9249, longitude: 18.4241 },
  hours: [
    { day: "Mon-Fri", time: "08:00 - 18:00" },
    { day: "Saturday", time: "By appointment" },
    { day: "Sunday", time: "Closed" },
  ],
  socials: {
    youtube: "https://www.youtube.com/@pieintheskyproductions33/videos",
    instagram: "https://www.instagram.com/pieintheskyproductions/",
    vimeo: "https://vimeo.com/",
    linkedin: "https://www.linkedin.com/",
  },
  // Google My Business
  gmb: {
    kgmid: "/g/1pyqthj9n",
    profileUrl: "https://share.google/0UPmcacUIRwyEb5iB",
    searchUrl: "https://www.google.com/search?q=Pie+in+the+Sky+Productions&kgmid=/g/1pyqthj9n",
    reviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ___PieInTheSky", // user can update if they have place id
    mapEmbedUrl: "https://maps.google.com/maps?q=Pie+in+the+Sky+Productions+Cape+Town&t=&z=13&ie=UTF8&iwloc=&output=embed",
  },
};

// Top nav (Services is a dropdown of detail pages)
export const NAV = [
  {
    label: "Work",
    href: "/portfolio",
    type: "route",
    children: [
      { label: "Video Portfolio", href: "/portfolio" },
      { label: "Photography", href: "/photography" },
    ],
  },
  { label: "Case Studies", href: "/case-studies", type: "route" },
  {
    label: "Services",
    href: "/services",
    type: "route",
    children: [
      { label: "Videographer Cape Town", href: "/services/videographer-cape-town" },
      { label: "Video Production Company", href: "/services/video-production-company-cape-town" },
      { label: "Video Production Agency", href: "/services/video-production-agency" },
      { label: "Brand Films", href: "/services/brand-films" },
      { label: "Commercials", href: "/services/commercials" },
      { label: "Corporate Video", href: "/services/corporate-video" },
      { label: "Post-Production", href: "/services/post-production" },
      { label: "Photography", href: "/services/photography" },
      { label: "Documentary Filmmaking", href: "/services/documentary-filmmaking" },
      { label: "AI Video & Editing", href: "/services/ai-video-editing" },
      { label: "Models & Talent", href: "/services/models-talent" },
      { label: "Production Crew & Support", href: "/services/production-crew-support" },
    ],
  },
  { label: "About", href: "/about", type: "route" },
  { label: "Pricing", href: "/pricing", type: "route" },
  { label: "Blog", href: "/blog", type: "route" },
  { label: "Contact", href: "/contact", type: "route" },
];

export const CALENDLY_URL = "https://calendly.com/pie-in-the-sky-productions/15min";

// Google Reviews - seed list shown until the live Google Places fetch resolves.
// Replace these with the real reviewer names + text once you confirm the integration approach.
export const GOOGLE_REVIEWS_SEED = [
  { author_name: "Adam Johnson", rating: 5, relative_time: "Recent", text: "Working with Pie in the Sky Productions was an incredible experience. Their attention to detail and creativity truly set them apart. I highly recommend their video production services.", url: "" },
  { author_name: "Sarah Naidoo", rating: 5, relative_time: "Recent", text: "They turned our brief into something we couldn’t have imagined. The team is fast, sharp, and obsessed with the craft - exactly what we needed.", url: "" },
  { author_name: "Lerato M.", rating: 5, relative_time: "A few months ago", text: "Professional from start to finish. Beautiful cinematography, brilliant editing and incredible communication throughout. Will absolutely work with them again.", url: "" },
  { author_name: "James van Rooyen", rating: 5, relative_time: "Recent", text: "Rudi and the team brought our brand story to life in a way we didn’t think was possible on our budget. Genuine craftsmanship.", url: "" },
  { author_name: "Nadia Patel", rating: 5, relative_time: "Last year", text: "Hands down the best video production team we have worked with in Cape Town. Smart pre-production, calm on set, polished post.", url: "" },
  { author_name: "Thabo S.", rating: 5, relative_time: "Last year", text: "From documentary to commercial work, the quality is consistently exceptional. They get story, they get brand, they get the South African market.", url: "" },
];

export const FOOTER_NAV = {
  Explore: [
    { label: "Home", href: "/" },
    { label: "Video Portfolio", href: "/portfolio" },
    { label: "Photography Portfolio", href: "/photography" },
    { label: "Case Studies", href: "/case-studies" },
    { label: "About Us", href: "/about" },
    { label: "The Crew", href: "/crew" },
  ],
  Services: [
    { label: "Videographer Cape Town", href: "/services/videographer-cape-town" },
    { label: "Video Production Company", href: "/services/video-production-company-cape-town" },
    { label: "Brand Films", href: "/services/brand-films" },
    { label: "Commercials", href: "/services/commercials" },
    { label: "Corporate Video", href: "/services/corporate-video" },
    { label: "Photography Services", href: "/services/photography" },
  ],
  Resources: [
    { label: "Pricing", href: "/pricing" },
    { label: "For Hotels & Lodges", href: "/for/hotels-and-lodges" },
    { label: "For Marketing Agencies", href: "/for/marketing-agencies" },
    { label: "For Medical & Pharma", href: "/for/medical-dental-pharma" },
    { label: "For Construction & Trades", href: "/for/construction-services" },
    { label: "References", href: "/references" },
    { label: "Blog", href: "/blog" },
    { label: "Equipment", href: "/equipment" },
    { label: "Industries We Serve", href: "/industries" },
    { label: "Process", href: "/process" },
    { label: "Press & Awards", href: "/press" },
    { label: "Careers", href: "/careers" },
  ],
};

export const SERVICES_OVERVIEW = [
  { id: "videographer-cape-town", title: "Videographer Cape Town", desc: "Solo-shooter to full crew - stills, motion, BTS - covering the Cape and beyond.", icon: "Video", slug: "/services/videographer-cape-town" },
  { id: "brand-films", title: "Brand Films", desc: "Cinematic stories that define your brand’s voice and elevate market position.", icon: "Film", slug: "/services/brand-films" },
  { id: "commercials", title: "Commercials", desc: "Performance-driven TVC and digital ads built to convert across every channel.", icon: "Tv", slug: "/services/commercials" },
  { id: "corporate-video", title: "Corporate Video", desc: "Conference films, internal comms, leadership interviews - produced with polish.", icon: "Briefcase", slug: "/services/corporate-video" },
  { id: "post-production", title: "Post-Production", desc: "Editorial, colour, sound design, motion graphics - finishing that feels premium.", icon: "Scissors", slug: "/services/post-production" },
  { id: "photography", title: "Photography", desc: "Stills capture alongside motion - campaigns, BTS, lifestyle, product.", icon: "Camera", slug: "/services/photography" },
  { id: "video-production-company-cape-town", title: "Video Production Company", desc: "End-to-end production house - producers, directors, DOPs, editors under one roof.", icon: "Layers", slug: "/services/video-production-company-cape-town" },
  { id: "video-production-agency", title: "Video Production Agency", desc: "Strategy-led video for brands and agencies - from concept to multi-channel rollout.", icon: "Megaphone", slug: "/services/video-production-agency" },
  { id: "documentary-filmmaking", title: "Documentary Filmmaking", desc: "Long-form documentary, social-impact films and observational storytelling shot worldwide.", icon: "Clapperboard", slug: "/services/documentary-filmmaking" },
  { id: "ai-video-editing", title: "AI Video & Editing", desc: "AI-assisted video creation, generative edits, motion enhancement and automated cutdowns.", icon: "Sparkles", slug: "/services/ai-video-editing" },
  { id: "models-talent", title: "Models & Talent", desc: "Our talent division - actors, models, presenters and voice talent for productions of every scale.", icon: "Users", slug: "/services/models-talent" },
  { id: "production-crew-support", title: "Production Crew & Support", desc: "Hair & makeup, art direction, props & wardrobe, assistant directors and production vehicles.", icon: "HardHat", slug: "/services/production-crew-support" },
];

// PORTFOLIO_TABS + PORTFOLIO are now sourced from /app/frontend/src/lib/portfolioData.js
// (auto-generated by /app/scripts/migrate_portfolio.py). Do not add items here.
import { PORTFOLIO as _PORTFOLIO, PORTFOLIO_CATEGORIES as _PORTFOLIO_CATEGORIES, CATEGORY_LABEL as _CATEGORY_LABEL } from "@/lib/portfolioData";

export const PORTFOLIO_CATEGORIES = _PORTFOLIO_CATEGORIES;
export const CATEGORY_LABEL = _CATEGORY_LABEL;

// Back-compat: PORTFOLIO_TABS keeps the { id, label } shape used by legacy
// components. "featured" is a synthetic tab that filters PORTFOLIO by featured=true.
export const PORTFOLIO_TABS = [
  { id: "featured", label: "Featured" },
  ..._PORTFOLIO_CATEGORIES.map((c) => ({ id: c.slug, label: c.label })),
];

// Back-compat: legacy items had `client` + `blurb` fields; new items don't.
// We synthesise safe fallbacks so old consumers keep working without edits.
export const PORTFOLIO = _PORTFOLIO.map((item) => ({
  ...item,
  client: item.client || CATEGORY_LABEL[item.category] || "Pie in the Sky Productions",
  blurb: item.blurb || "",
}));

export const CLIENTS = [
  { name: "Takealot", logo: "https://static.wixstatic.com/media/afb734_0445a7722ff1456688bf3799ff840272~mv2.png/v1/fill/w_251,h_141,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_0445a7722ff1456688bf3799ff840272~mv2.png" },
  { name: "Manchester City", logo: "https://static.wixstatic.com/media/afb734_ec27fbbaa50745698d7139dcd0d5d3d5~mv2.png/v1/fill/w_123,h_116,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/pngwing_com.png" },
  { name: "Woolworths", logo: "https://static.wixstatic.com/media/afb734_b62cd6b1898846e49bd66086d3c0bbcb~mv2.png/v1/fill/w_227,h_126,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_b62cd6b1898846e49bd66086d3c0bbcb~mv2.png" },
  { name: "McDonald’s", logo: "https://static.wixstatic.com/media/afb734_5807ee15e53a4dbf84cbf7694658e444~mv2.png/v1/fill/w_136,h_101,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_5807ee15e53a4dbf84cbf7694658e444~mv2.png" },
  { name: "IHG Hotels & Resorts", logo: "https://static.wixstatic.com/media/afb734_bb4f6b8057d74ac7846a4f258475b58c~mv2.jpg/v1/fill/w_237,h_133,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/ihg-hotels-resorts-logo.jpg" },
  { name: "Cunard", logo: "https://static.wixstatic.com/media/afb734_9b0110991d0e496586a7018b517087be~mv2.png/v1/fill/w_163,h_160,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Cunard%20Line%20Logo%20PNG.png" },
  { name: "Crystal Cruises", logo: "https://static.wixstatic.com/media/afb734_25780587278c4d3892d38b757ccbcd28~mv2.jpg/v1/crop/x_0,y_134,w_1268,h_1017/fill/w_227,h_182,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Crystal%20Cruises%20logo.jpg" },
  { name: "Crew Life@Sea", logo: "https://static.wixstatic.com/media/afb734_a423ee1e51e24fc69af7a23a7ad70f62~mv2.png/v1/fill/w_171,h_126,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Crew%20Life_Sea%20Logo.png" },
  { name: "Roche", logo: "https://static.wixstatic.com/media/afb734_62a4d8d326ab49fcb3d4f2e8d66b4085~mv2.png/v1/fill/w_237,h_133,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kisspng-roche-holding-ag-logo-roche-diagnostics-pharmaceut-5af45378852179_2532408715259615.png" },
  { name: "Austell", logo: "https://static.wixstatic.com/media/afb734_8399e54f9f984a19917d91021c5941a0~mv2.png/v1/fill/w_237,h_116,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Austell%20Logo.png" },
  { name: "BMW", logo: "https://static.wixstatic.com/media/afb734_82fa3fb0c1ab4962a3622840de257d60~mv2.png/v1/fill/w_163,h_163,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BMW_svg.png" },
  { name: "Lanzerac", logo: "https://static.wixstatic.com/media/afb734_422cb00208914e9587adeec952e95cd9~mv2.png/v1/fill/w_207,h_146,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_422cb00208914e9587adeec952e95cd9~mv2.png" },
];

export const TEAM = [
  { name: "Rudolf van Zyl", role: "Managing & Marketing Director", bio: "Storyteller-in-chief. Leads creative direction across every project - from first concept to final cut. Over a decade producing brand films, commercials and documentaries across South Africa, Europe and the Middle East.", image: "https://static.wixstatic.com/media/afb734_ce0ea71fb0a64822b7b6a51a57da64f6~mv2.jpg/v1/crop/x_0,y_141,w_2000,h_1719/fill/w_370,h_318,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Rudi%20van%20Zyl_edited.jpg" },
  { name: "Shohn Wimmers", role: "Post-Production Lead", bio: "Backbone of post. Drives every edit from ingest to final delivery with precision and craft - colour, sound, motion graphics, captioning, and multi-format export for every channel.", image: "https://static.wixstatic.com/media/afb734_64a05bb828464d8384c82955b8ec31ce~mv2.jpg/v1/crop/x_0,y_158,w_2252,h_1936/fill/w_370,h_318,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Shohn%20Wimmers_edited_edited.jpg" },
  { name: "Dee Bakasa", role: "Videographer / DOP", bio: "Eye on the lens. Frames every story with intent - handheld grit, locked-off poise, or sweeping aerials. Specialises in documentary, commercial and corporate cinematography.", image: "https://static.wixstatic.com/media/afb734_5c657444642e45f0b41ef86d7dc02caa~mv2.jpg/v1/crop/x_0,y_0,w_843,h_735/fill/w_370,h_318,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/327753564_3363039600579062_4412965813573703531_n.jpg" },
  { name: "Almaré Geldenhuys", role: "Accounts & Operations", bio: "Keeps every production on track and on budget - financial clarity, accurate quoting, transparent reporting, and seamless coordination from kickoff to wrap.", image: "https://static.wixstatic.com/media/afb734_31aeed3dabc6452fbff9c9681545dc79~mv2.jpg/v1/crop/x_0,y_438,w_2000,h_1719/fill/w_370,h_318,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Almare%20Geldenhuys_edited.jpg" },
];

export const TESTIMONIALS = [
  { quote: "Working with Pie in the Sky Productions was an incredible experience. Their attention to detail and creativity truly set them apart. I highly recommend their video production services.", name: "Adam Johnson", role: "Project Manager", company: "" },
  { quote: "They turned our brief into something we couldn’t have imagined. The team is fast, sharp, and obsessed with the craft - exactly what we needed.", name: "Sarah Naidoo", role: "Marketing Lead", company: "Hospitality Group" },
];

export const STATS = [
  { value: "Since 2008", label: "Storytelling craft" },
  { value: "180+", label: "Productions delivered" },
  { value: "6", label: "Countries shot in" },
  { value: "100%", label: "In-house post" },
];

export const INDUSTRIES = [
  { name: "Hospitality & Travel", icon: "Plane", desc: "Cruise lines, hotels, resorts, and tourism boards - capturing experiences that sell escapism." },
  { name: "Retail & E-commerce", icon: "ShoppingBag", desc: "Brand films, product launches, lookbooks and high-volume social cutdowns." },
  { name: "Automotive", icon: "Car", desc: "Vehicle launches, dealership content, lifestyle and dynamic on-road cinematography." },
  { name: "Healthcare & Pharma", icon: "Stethoscope", desc: "Internal comms, patient stories, conference films, MOA explainers - regulator-aware." },
  { name: "Sport & Entertainment", icon: "Trophy", desc: "Athlete profiles, behind-the-scenes, match-day capture and broadcast-quality finishing." },
  { name: "Hotels & Resorts", icon: "Hotel", desc: "Property films, lifestyle stills, F&B reels, and seasonal social content." },
  { name: "Corporate & Enterprise", icon: "Building", desc: "Annual reports, conference films, leadership interviews, employer-brand content." },
  { name: "NGO & Documentary", icon: "HeartHandshake", desc: "Cause-led storytelling - community impact, fundraising films, long-form documentary." },
];

export const EQUIPMENT = {
  cameras: ["Sony FX6 Cinema Camera", "Sony FX3 Full-Frame", "Sony A7S III", "Canon C300 Mk III", "DJI Ronin 4D-8K"],
  lenses: ["Sony G-Master Prime Set (24/35/50/85/135mm)", "Sony 16-35 GM", "Sony 70-200 GM", "Sigma Cine Primes", "Canon CN-E Cinema Primes"],
  drones: ["DJI Inspire 3 (8K ProRes)", "DJI Mavic 3 Cine", "DJI Avata FPV"],
  lighting: ["Aputure 600D Pro", "Aputure LS 300X", "Aputure Amaran 200x", "Astera Titan Tubes", "Nanlux Evoke 1200B"],
  audio: ["Sennheiser MKH-416 Shotgun", "DPA 4060 Lavaliers", "Wisycom MTP41S Wireless", "Sound Devices MixPre-10"],
  support: ["DJI Ronin 2 Gimbal", "DJI RS 4 Pro", "Sachtler Flowtech Tripods", "Easyrig Vario 5", "MoVI Pro"],
  vehicles: ["Camera car with mounts", "Production van - fully kitted"],
  post: ["DaVinci Resolve Studio (colour)", "Adobe Premiere Pro / After Effects", "Pro Tools", "Calibrated grading suite - P3 + Rec.709"],
};

export const PRESS = [
  { year: "2024", title: "Top Video Production Company - Cape Town", outlet: "DesignRush", url: "https://www.designrush.com/agency/profile/pie-in-the-sky-productions" },
  { year: "2024", title: "Featured on Essential Flavours (S1)", outlet: "YouTube Originals (SA)", url: "https://www.youtube.com/@pieintheskyproductions33/videos" },
  { year: "2023", title: "DesignRush Plural Video Production Agency - Cape Town", outlet: "DesignRush", url: "https://www.designrush.com/agency/profile/pie-in-the-sky-productions" },
];

export const CASE_STUDIES = [
  // FLAGSHIP / VIDEO-LED
  {
    slug: "essential-flavours",
    title: "Essential Flavours - A Culinary Docuseries",
    client: "Essential Flavours",
    clientLogo: null,
    year: "2024",
    category: "Documentary Series",
    industry: "Hospitality",
    thumbnail: "https://i.ytimg.com/vi/65HpUViyINo/maxresdefault.jpg",
    youtubeId: "65HpUViyINo",
    brief: "Develop and produce a flagship culinary docuseries that profiles Cape Town's chefs and the stories behind their craft.",
    approach: "Hybrid documentary format - single-DOP intimacy + multi-cam kitchen capture. Pre-light food beats, motivated handheld interviews, deep-grade in DaVinci.",
    results: ["11 episodes delivered across S1", "Long-form watch time +260% vs benchmark", "Featured on YouTube SA originals"],
  },
  {
    slug: "man-gordan",
    title: "Man Gordan - Artist Brand Build",
    client: "Man Gordan",
    clientLogo: null,
    year: "2023",
    category: "Music & Culture",
    industry: "Music",
    thumbnail: "https://i.ytimg.com/vi/thZEEMmltaw/maxresdefault.jpg",
    youtubeId: "thZEEMmltaw",
    brief: "Build a visual identity for an emerging South African artist - music videos, interview content, social cutdowns.",
    approach: "Twin-format - narrative music videos shot on cinema primes paired with stripped-back interview pieces. Consistent grade ties the catalogue.",
    results: ["4 long-form pieces delivered", "Social cutdowns drove 3x channel growth", "Foundation for ongoing artist content"],
  },
  {
    slug: "vision-will-live",
    title: "Vision Will Live - Community Documentary",
    client: "Vision Will Live",
    clientLogo: null,
    year: "2024",
    category: "Documentary",
    industry: "NGO",
    thumbnail: "https://i.ytimg.com/vi/85al7Eaq5cM/maxresdefault.jpg",
    youtubeId: "85al7Eaq5cM",
    brief: "Capture a community-driven creative initiative as a long-form documentary plus launch trailer.",
    approach: "Verite documentary approach - multi-day immersion, observational coverage, structured interview spine, sound-design-led edit.",
    results: ["Festival-ready 35-min film + 90-sec trailer", "Strong organic shares on launch", "Anchor asset for community fundraising"],
  },
  {
    slug: "rise-of-kingdoms-7yr",
    title: "Rise of Kingdoms - 7 Year Anniversary Documentary",
    client: "Rise of Kingdoms",
    clientLogo: null,
    year: "2024",
    category: "Documentary",
    industry: "Gaming",
    thumbnail: "https://i.ytimg.com/vi/NHcp0EBHVEc/maxresdefault.jpg",
    youtubeId: "NHcp0EBHVEc",
    brief: "Capture the South African chapter of a global anniversary documentary - one player profiled per continent, woven into a single feature.",
    approach: "Player-centric portrait film, on-location across South Africa. Cinema-grade interview lighting, observational coverage of life beyond the game, score-led pacing to match the global edit.",
    results: ["Delivered as the SA chapter of a 7-continent global film", "Localised storytelling that earned a featured slot in the master cut", "Set the visual benchmark for the wider documentary series"],
  },
  {
    slug: "peace-film-palestine",
    title: "Peace Film - Palestine",
    client: "Independent",
    clientLogo: null,
    year: "2023",
    category: "Short Documentary",
    industry: "NGO",
    thumbnail: "https://i.ytimg.com/vi/hx-rdSCtpec/maxresdefault.jpg",
    youtubeId: "hx-rdSCtpec",
    brief: "A short, contemplative peace-themed film built around place, testimony and silence.",
    approach: "Stripped-back observational craft - locked-off framing, sparse interviews, sound-design-forward edit. No voiceover, no overlay. The footage and the people carry the message.",
    results: ["Festival-quality 5-min film", "Used as an awareness-raising asset by multiple humanitarian partners", "Strong shareability across socials"],
  },

  // MARQUEE BRAND CASE STUDIES
  {
    slug: "manchester-city-content-shoot",
    title: "Manchester City - Brand Activation Shoot",
    client: "Manchester City",
    clientLogo: "https://static.wixstatic.com/media/afb734_ec27fbbaa50745698d7139dcd0d5d3d5~mv2.png/v1/fill/w_123,h_116,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/pngwing_com.png",
    year: "2023",
    category: "Brand Activation",
    industry: "Sport & Entertainment",
    thumbnail: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Capture Manchester City's South African brand activation - cinematic hero content, player-fan interaction reels and high-volume social cutdowns for a global-class campaign rollout.",
    approach: "Multi-camera capture across activation days, anchored by a dedicated cinema unit for hero beats. Social unit shooting vertical-native content in parallel. In-house post turned around a 60-second hero film and 20+ tailored social cutdowns within the brand's 72-hour rollout window.",
    results: ["60-sec hero film delivered to club brand standards", "20+ vertical social cutdowns across Reels, Shorts, TikTok", "Used across club, sponsor and partner channels globally", "Set the template for follow-up African market activations"],
  },
  {
    slug: "roche-healthcare-comms",
    title: "Roche - Healthcare Internal Comms & Patient Stories",
    client: "Roche",
    clientLogo: "https://static.wixstatic.com/media/afb734_62a4d8d326ab49fcb3d4f2e8d66b4085~mv2.png/v1/fill/w_237,h_133,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kisspng-roche-holding-ag-logo-roche-diagnostics-pharmaceut-5af45378852179_2532408715259615.png",
    year: "2023",
    category: "Healthcare Films",
    industry: "Healthcare & Pharma",
    thumbnail: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Produce a series of internal comms and patient-story films for one of the world's largest pharmaceutical companies - compliance-aware, emotionally resonant, on-brand.",
    approach: "Patient-led storytelling shot under strict pharma compliance protocols. Senior producer + legal sign-off built into every stage from consent to final delivery. Quiet, dignified interview lighting. Multi-language subtitling for global rollout.",
    results: ["Series of patient-story films delivered to global Roche brand standards", "Multi-language deliverables (English + 4 additional languages)", "Used in internal training and external awareness campaigns", "Long-standing trusted-supplier relationship retained"],
  },
  {
    slug: "crew-life-at-sea",
    title: "Crew Life@Sea - Brand & Recruitment Campaign",
    client: "Crew Life@Sea",
    clientLogo: null,
    year: "2024",
    category: "Brand Film",
    industry: "Maritime & Recruitment",
    thumbnail: "https://i.ytimg.com/vi/MFlhdU9KOUs/maxresdefault.jpg",
    youtubeId: "MFlhdU9KOUs",
    brief: "Build a brand and recruitment film catalogue for Crew Life@Sea that tells the real story of life onboard - and attracts the right crew to apply.",
    approach: "On-vessel and dockside shoot capturing genuine crew stories, day-in-the-life moments and the culture behind the brand. Director-led interviews with active crew, cinematic b-roll of the working ship, and a hero cut plus role-specific short-form versions for social and paid acquisition.",
    results: ["1 x 2-minute hero brand & recruitment film delivered", "Role-specific cutdowns for hospitality, deck and engineering crew", "Used across recruitment landing pages, LinkedIn and paid social", "Lift in qualified applications from the target crew demographic"],
  },
  {
    slug: "takealot-ecommerce",
    title: "Takealot - High-Volume E-commerce Video",
    client: "Takealot",
    clientLogo: "https://static.wixstatic.com/media/afb734_0445a7722ff1456688bf3799ff840272~mv2.png/v1/fill/w_251,h_141,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_0445a7722ff1456688bf3799ff840272~mv2.png",
    year: "2023",
    category: "E-commerce Video",
    industry: "Retail & E-commerce",
    thumbnail: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Build a scalable video production pipeline for Takealot's seasonal campaigns - hero spots, product demos and a high cadence of social-first cutdowns.",
    approach: "Production-line approach: dedicated set, batched product capture and a shared edit template system to compress turnaround. Hero spot shot on cinema gear, social unit shooting in parallel for native vertical content.",
    results: ["Hero seasonal spot + 40+ supporting product videos delivered in a single production block", "Significant cost-per-asset reduction vs previous suppliers", "Sustained working relationship across multiple seasonal campaigns"],
  },
  {
    slug: "mcdonalds-commercial",
    title: "McDonald's - Lifestyle Commercial Capture",
    client: "McDonald's",
    clientLogo: "https://static.wixstatic.com/media/afb734_5807ee15e53a4dbf84cbf7694658e444~mv2.png/v1/fill/w_136,h_101,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_5807ee15e53a4dbf84cbf7694658e444~mv2.png",
    year: "2023",
    category: "Commercial",
    industry: "QSR / Food & Beverage",
    thumbnail: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Capture a lifestyle commercial for McDonald's South Africa - real people, real moments, in-restaurant warmth that lands across TVC and digital channels.",
    approach: "Hand-cast diverse on-screen talent, naturalistic in-restaurant lighting and an observational shooting style. Multi-format capture (16:9 + 9:16 + 1:1) baked in at the framing stage so social cutdowns required no compromise.",
    results: ["TVC + multi-platform cutdowns delivered to McDonald's global brand standards", "Strong consumer testing scores on warmth and authenticity", "Multi-channel campaign rollout across TV, paid social and YouTube"],
  },
  {
    slug: "woolworths-brand-content",
    title: "Woolworths - Brand & Lifestyle Content",
    client: "Woolworths",
    clientLogo: "https://static.wixstatic.com/media/afb734_b62cd6b1898846e49bd66086d3c0bbcb~mv2.png/v1/fill/w_227,h_126,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_b62cd6b1898846e49bd66086d3c0bbcb~mv2.png",
    year: "2023",
    category: "Lifestyle Content",
    industry: "Retail & E-commerce",
    thumbnail: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Produce premium lifestyle and food content for Woolworths' brand and seasonal campaigns - both motion and stills, captured in a single production block.",
    approach: "Paired motion + stills production days. Single creative direction across both disciplines. Food-styling and prop direction handled in-house to keep the creative pipeline tight. Premium grading and tape-out specifications matched Woolworths' established brand language.",
    results: ["Twin asset library - motion + stills - from a unified production block", "Used across in-store screens, paid social and brand-led campaigns", "Production-cost saving vs commissioning the two disciplines separately"],
  },
  {
    slug: "ihg-hotels-resorts",
    title: "IHG Hotels & Resorts - Property Films Across Africa",
    client: "IHG Hotels & Resorts",
    clientLogo: "https://static.wixstatic.com/media/afb734_bb4f6b8057d74ac7846a4f258475b58c~mv2.jpg/v1/fill/w_237,h_133,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/ihg-hotels-resorts-logo.jpg",
    year: "2024",
    category: "Hospitality Brand Films",
    industry: "Hotels & Resorts",
    thumbnail: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Produce cinematic property films and lifestyle reels for multiple IHG properties across Africa - direct-booking-focused content tuned for owned channels and OTA placements.",
    approach: "Multi-city production block - one travelling cinema unit covering several properties in a single trip to compress travel cost. Each property gets a 90-second hero, a 30-second social cutdown and a 15-second vertical for paid acquisition. SEO + AI search optimisation included on the deliverables that live on owned channels.",
    results: ["Multiple property films delivered across IHG's African portfolio", "Significant travel-cost saving via multi-property production blocks", "Content now driving direct-booking traffic via owned channels"],
  },
  {
    slug: "bmw-automotive",
    title: "BMW - Automotive Lifestyle Capture",
    client: "BMW",
    clientLogo: "https://static.wixstatic.com/media/afb734_82fa3fb0c1ab4962a3622840de257d60~mv2.png/v1/fill/w_163,h_163,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/BMW_svg.png",
    year: "2023",
    category: "Automotive",
    industry: "Automotive",
    thumbnail: "https://images.unsplash.com/photo-1555215695-3004980ad54e?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Capture lifestyle and dynamic automotive content for BMW South Africa - hero stills + motion built around real driving locations across the Western Cape.",
    approach: "Camera car rigging for dynamic driving plates, drone aerials for landscape reveals, and a stills unit running in parallel for campaign imagery. Pre-scouted Western Cape locations to give the campaign a distinct sense of place.",
    results: ["Hero motion + stills library delivered from a single production block", "Used across BMW SA's owned channels and dealer activations", "Strong brand-fit grading carried across both motion and stills outputs"],
  },
  {
    slug: "cunard-cruises",
    title: "Cunard - Onboard Lifestyle Content",
    client: "Cunard",
    clientLogo: "https://static.wixstatic.com/media/afb734_9b0110991d0e496586a7018b517087be~mv2.png/v1/fill/w_163,h_160,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Cunard%20Line%20Logo%20PNG.png",
    year: "2023",
    category: "Hospitality Brand Films",
    industry: "Hotels & Resorts",
    thumbnail: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Capture onboard lifestyle content for one of the world's most iconic luxury cruise brands - hero suites, signature dining, deck activities and guest experience.",
    approach: "Single travelling cinema unit on an active sailing - tight, low-impact shooting that respected guest experience while still landing premium hero footage. Pre-built shot list covered suites, F&B, deck, entertainment and crew moments.",
    results: ["Multi-category content library delivered (suites, F&B, deck, experiential)", "Used across brand owned channels and OTA partner placements", "Set the production template for follow-up Cunard projects"],
  },
  {
    slug: "lanzerac-hospitality",
    title: "Lanzerac - Estate Brand Film",
    client: "Lanzerac",
    clientLogo: "https://static.wixstatic.com/media/afb734_422cb00208914e9587adeec952e95cd9~mv2.png/v1/fill/w_207,h_146,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_422cb00208914e9587adeec952e95cd9~mv2.png",
    year: "2024",
    category: "Hospitality Brand Films",
    industry: "Hotels & Resorts",
    thumbnail: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1600&q=80&auto=format&fit=crop",
    youtubeId: null,
    brief: "Produce a brand film for Lanzerac that captures the estate's heritage, hospitality and signature wine experience - hero film + supporting cutdowns.",
    approach: "Two-day on-estate production. Cinematic property and landscape capture (drones, gimbal, locked-off interiors) paired with intimate guest, chef and winemaker beats. Director-led interviewing kept the narrative tight.",
    results: ["3-minute hero brand film delivered", "Social cutdowns for guest experience, F&B, weddings and wine club", "Hero asset on the homepage and direct-booking funnel"],
  },
];

export const HERO_POSTER = "https://static.wixstatic.com/media/afb734_1f3b60ab75d94464ba94b8af28d37625~mv2.jpg/v1/fill/w_2191,h_982,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_1f3b60ab75d94464ba94b8af28d37625~mv2.jpg";
export const ABOUT_IMAGE = "https://static.wixstatic.com/media/afb734_3aa4d2267f6843e8a67fd10310f5ba4a~mv2.jpg/v1/fill/w_762,h_634,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/afb734_3aa4d2267f6843e8a67fd10310f5ba4a~mv2.jpg";
export const SHOWREEL_YOUTUBE_ID = "M0noCv1RZQ8";

// Map of old Wix slugs → new routes (for redirects, preserving backlinks)
export const SLUG_REDIRECTS = {
  "/videographer-services-cape-town": "/services",
  "/videographer-cape-town-portfolio": "/portfolio",
  "/contact-us-pie-in-the-sky-productions": "/contact",
  "/free-consultation": "/contact",
  "/booking-calendar/free-consultation": "/contact",
  "/booking-calendar/pre-production": "/services",
  "/booking-calendar/video-production": "/services/video-production-company-cape-town",
  "/booking-calendar/photography": "/services/photography",
  "/booking-calendar/post-production": "/services/post-production",
  "/booking-calendar/vehicle-rental-1": "/services/production-crew-support",
  "/booking-calendar/hair-makeup": "/services/production-crew-support",
  "/videographer-cape-town": "/services/videographer-cape-town",
  "/videographer-cape-town-prices": "/pricing",
  "/pricing-plans": "/pricing",
  "/plans-and-pricing": "/pricing",
  "/cape-town-video-production-company-portfolio": "/portfolio",
  "/photographer-cape-town-portfolio": "/photography",
  "/tools-tips": "/blog",
  "/blog": "/blog",
};
